<template>
  <dx-chart :commonSeriesSettings="commonSeriesSettings"
            :seriesTemplate="seriesTemplate"
            :dataSource="dataSource"
            :argumentAxis="argumentAxis"
            :valueAxis="valueAxis"
            :visible.sync="visible"
            :export="getExport"
            :customizePoint="customizePoint"
            :legend="legend"
            style="width: 500px;" />
</template>

<script>
import { DxChart } from 'devextreme-vue';

export default {
  name: 'ClusterChart',

  components:{
    DxChart
  },

  props: {
    colors: { type: Array,
      default: () => {
        return [
          {"name":"red","color":"#FF1500","imageAsset":null,"min":0,"max":69},
          {"name":"orange","color":"#FF6A00","imageAsset":null,"min":70,"max":79},
          {"name":"yellow","color":"#FFD800","imageAsset":null,"min":80,"max":89},
          {"name":"green","color":"#4CFF00","imageAsset":null,"min":90,"max":100}
        ]
      }
    },
    argumentAxis: {
      label: {
        overlappingBehavior: "staggered"
      }
    },
    dataSource : Array,
    exportEnabled: { type: Boolean, default: false },
    headerSubText: { type: String, default: "(Sub Header)" },
    headerText: { type: String, default: "Header Text" },
    palette: { type: String, default: 'violet' },
    visible: { type: Boolean, default: true}
  },

  data() {
    return {
      gaugefontsize: 28,
      legend: {
        visible: false,
        verticalAlignment: "bottom",
        horizontalAlignment: "center"
      },
      commonSeriesSettings: {
        argumentField: "arg",
        valueField: "val",
        type: "line",
        label: {
          backgroundColor: 'transparent',
          position: 'inside',
          alignment: 'center',
          verticalOffset: 200,
          rotationAngle:-90,
          visible: true,
          font: {
            color: "#111111",
            family: "Segoe UI",
            opacity: 1,
            size: 15,
            weight: 400
          },
          format: {
            type: "fixedPoint",
            precision: 0
          },
          customizeText: function (item) {
            return item.seriesName + ': ' + item.value + '%';
          }
        },
        border: {
          color: "#999999",
          visible: true,
          width: 0.5
        },
        minorTick: {

        }
      },
      seriesTemplate: {
        nameField: "secondary",
        customizeSeries: function(valueFromNameField) {
          return {
            type: "line",
            label: {
              visible: true
            },
            color: "#ff3f7a"
          };
        }
      },
      valueAxis: {
        visualRange: {
          startValue: 0,
          endValue: 100
        },
        valueMarginsEnabled:false,
        label: {
          font: {
            color: '#000000'
          },
          customizeText: function (item) {
            return item.value + '%';
          }
        }
      }
    };
  },

  computed: {
    getTitle: function() {
      return { text: this.headerText, font: { size: this.gaugefontsize }, subtitle: { text: this.headerSubText } }
    },
    getExport: function() {
      return { enabled: this.exportEnabled };
    }
  },

  methods: {
    customizePoint: function(item) {
      let result = {
        color: 'black',
        size: 10,
        label: {
          visible: true
        },
      };
      if (this.colors) {
        this.colors.forEach(element => {
          if (item.data.percent <= element.max && item.data.percent >= element.min) {
            result.color = element.color;
          }
        });
      }
      return result;
    }
  }
}

</script>

<style scoped>

 td {
    vertical-align: middle;
}

</style>
